export enum ThemeNews {
    NEWS = "News",
    INFORMATION_FINANCIERE = "Information financière",
    COMMUNIQUE_DE_PRESSE = "Communiqué de presse",
    NEWS_ECONOMIQUE_NATIONALE = "News économique nationale",
    NEWS_ECONOMIQUE_INTERNATIONALE = "News économique internationale",
    NEWS_DES_SOCIETES_COTEES = "News des sociétés cotées"

}
